import OBJ0 from "../assets/hotdog/shape0_0.obj";
import OBJ1 from "../assets/hotdog/shape0_1.obj";
import OBJ2 from "../assets/hotdog/shape0_2.obj";
import OBJ3 from "../assets/hotdog/shape0_3.obj";
import OBJ4 from "../assets/hotdog/shape0_4.obj";
import OBJ5 from "../assets/hotdog/shape0_5.obj";
import OBJ6 from "../assets/hotdog/shape0_6.obj";
import OBJ7 from "../assets/hotdog/shape0_7.obj";

import OBJ8 from "../assets/hotdog/shape1_0.obj";
import OBJ9 from "../assets/hotdog/shape1_1.obj";
import OBJ10 from "../assets/hotdog/shape1_2.obj";
import OBJ11 from "../assets/hotdog/shape1_3.obj";
import OBJ12 from "../assets/hotdog/shape1_4.obj";
import OBJ13 from "../assets/hotdog/shape1_5.obj";
import OBJ14 from "../assets/hotdog/shape1_6.obj";
import OBJ15 from "../assets/hotdog/shape1_7.obj";

import PNG0 from "../assets/hotdog/shape0.pngfeat0.png";
import PNG1 from "../assets/hotdog/shape0.pngfeat1.png";
import PNG2 from "../assets/hotdog/shape1.pngfeat0.png";
import PNG3 from "../assets/hotdog/shape1.pngfeat1.png";

import JSON from "../assets/hotdog/mlp.json";

const HOTDOG = [
  OBJ0,
  OBJ1,
  OBJ2,
  OBJ3,
  OBJ4,
  OBJ5,
  OBJ6,
  OBJ7,
  OBJ8,
  OBJ9,
  OBJ10,
  OBJ11,
  OBJ12,
  OBJ13,
  OBJ14,
  OBJ15,
  PNG0,
  PNG1,
  PNG2,
  PNG3,
  JSON,
];

export default HOTDOG;
